import React from "react";

type Props = {
    visible: boolean;
    title: string;
    maxWidth?: string;
    onClose: (() => Promise<void>) | (() => void);
    children: React.ReactNode;
    customModalTopPosition?: string | number;
    /** Greys out and blocks the header X, e.g. while a submission is in flight. */
    closeDisabled?: boolean;
}

export function ReportModal({visible, onClose, title, children, customModalTopPosition = 0, maxWidth = 'max-w-4xl', closeDisabled = false}: Props) {
    const useCustomPosition = customModalTopPosition !== 0;
    const closeButtonClass = "text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white"
        + (closeDisabled ? " opacity-40 pointer-events-none" : "");
    
    return (
        <div
            className={(visible ? "flex " : "hidden ") + "overflow-y-auto overflow-x-hidden fixed z-50 justify-center items-start inset-0"}
            style={{backgroundColor: "rgba(0,0,0,0.4)"}}>
            {useCustomPosition ? (
                // Custom positioning for components that need it
                <div className={`flex items-center justify-center min-h-full w-full px-4 py-6`}>
                    <div className={`relative w-full ${maxWidth}`}>
                        <div className="relative bg-white rounded-lg shadow dark:bg-gray-700 flex flex-col max-h-[90vh]"
                             style={{marginTop: customModalTopPosition}}>
                            <div className="flex justify-between items-start p-4 rounded-t border-b dark:border-gray-600 flex-shrink-0">
                                <h3 className="text-base font-semibold text-gray-900 dark:text-white">
                                    {title}
                                </h3>
                                <button type="button"
                                        className={closeButtonClass}
                                        disabled={closeDisabled}
                                        onClick={onClose}
                                >
                                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path fillRule="evenodd"
                                              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                              clipRule="evenodd"/>
                                    </svg>
                                </button>
                            </div>
                            <div className="overflow-y-auto">
                                {children}
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                // Flexbox centering for components that don't need custom positioning
                <div className={`flex items-center justify-center min-h-full w-full px-4 py-6`}>
                    <div className={`relative w-full ${maxWidth}`}>
                        <div className="relative bg-white rounded-lg shadow dark:bg-gray-700 flex flex-col max-h-[90vh]">
                            <div className="flex justify-between items-start p-4 rounded-t border-b dark:border-gray-600 flex-shrink-0">
                                <h3 className="text-base font-semibold text-gray-900 dark:text-white">
                                    {title}
                                </h3>
                                <button type="button"
                                        className={closeButtonClass}
                                        disabled={closeDisabled}
                                        onClick={onClose}
                                >
                                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path fillRule="evenodd"
                                              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                              clipRule="evenodd"/>
                                    </svg>
                                </button>
                            </div>
                            <div className="overflow-y-auto">
                                {children}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}
